// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "f9ae08dd7b42c51d2315be85d858daf1" + ".js";
};